import PublicNavbar from "./PublicNavbar"
import Footer from "./Footer"
import ShortcutsDialog from "./ShortcutsDialog"
import { useKeyboardShortcuts } from "../../hooks/useKeyboardShortcuts"
import { useAuthStore } from "../../stores/authStore"
import { RouteTransition } from "@/components/page"

interface LayoutProps {
  children: React.ReactNode
}

export default function PublicLayout({ children }: LayoutProps) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const isStudent = useAuthStore((s) => s.sessionType !== "group")
  // Con sesión, los atajos también funcionan en el catálogo y demás páginas públicas.
  const shortcuts = useKeyboardShortcuts(isAuthenticated, isStudent)

  return (
    <div className="flex flex-col min-h-screen w-full selection:bg-primary/20 overflow-x-hidden antialiased">
      <PublicNavbar />
      <main className="flex-1 w-full">
        <RouteTransition>{children}</RouteTransition>
      </main>
      <Footer />
      {isAuthenticated && (
        <ShortcutsDialog
          open={shortcuts.open}
          onOpenChange={shortcuts.setOpen}
          enabled={shortcuts.enabled}
          onEnabledChange={shortcuts.setEnabled}
          isStudent={isStudent}
        />
      )}
    </div>
  )
}
